import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { toast } from 'sonner';
import HolidaysTab from './HolidaysTab';
import TeamManagementOverviewTab from './TeamManagementOverviewTab';
import TeamTabs from './TeamTabs';
import TimeOffLogTab from './TimeOffLogTab';
import { makeRESTApiRequest } from '../../../helpers/api';
import { ADMIN_ROLE, ENDPOINTS, PROCESSOR_ROLE, SALES_PERSON_ROLE } from '../../../helpers/constants';

const TEAM_MANAGEMENT_TABS = [
  { value: 'birthdays', label: 'Team Members' },
  { value: 'teamOff', label: 'Time Off' },
  { value: 'holidays', label: 'Holidays' }
];

const TeamManagement = () => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(TEAM_MANAGEMENT_TABS[0].value);
  const [teamMembers, setTeamMembers] = useState([]);

  const fetchTeamMembers = async ({ showLoading = false } = {}) => {
    if (showLoading) setLoading(true);
    const { response, error } = await makeRESTApiRequest({
      endpoint: ENDPOINTS.USERS_SEARCH,
      method: 'POST',
      requestBody: {
        filter: {
          role: {
            $in: [ADMIN_ROLE, PROCESSOR_ROLE, SALES_PERSON_ROLE]
          }
        }
      }
    });

    if (error) {
      toast.error(error);
      if (showLoading) setLoading(false);
      return;
    }

    setTeamMembers(Array.isArray(response) ? response : []);
    if (showLoading) setLoading(false);
  };

  useEffect(() => {
    fetchTeamMembers({ showLoading: true });
  }, []);

  return (
    <Container
      fluid
      className="d-flex flex-column py-3 px-md-3"
      style={{ backgroundColor: '#FAFAFA', minHeight: 'calc(100vh - 64px)' }}
    >
      <div className="p-3">
        <div>
          <div style={{ flexShrink: 0 }}>
            <h6 className="font-weight-bold xxxlargeFont">Team Management</h6>
            <p className="text-muted midFont">Manage team members and time-off requests</p>
          </div>

          <div className="mt-4">
            <TeamTabs tabs={TEAM_MANAGEMENT_TABS} activeTab={activeTab} onTabSelect={setActiveTab} />
            <div className="mt-3 flex-grow-1">
              {activeTab === 'birthdays' && (
                <TeamManagementOverviewTab
                  teamMembers={teamMembers}
                  isTeamMembersLoading={loading}
                  onRefreshTeamMembers={fetchTeamMembers}
                />
              )}
              {activeTab === 'teamOff' && (
                <TimeOffLogTab
                  teamMembers={teamMembers}
                  isTeamMembersLoading={loading}
                  onRefreshTeamMembers={fetchTeamMembers}
                />
              )}
              {activeTab === 'holidays' && <HolidaysTab />}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default TeamManagement;
